<template>
	<div class="gedit-template-card" :class="[`gedit-template-card--${variant}`, { 'is-phone': variant === 'phone' }]">
		<div class="gedit-template-card__cover">
			<div v-if="variant === 'phone'" class="gedit-template-card__phone-wrap">
				<div class="gedit-template-card__phone">
					<img
						v-if="item.cover"
						class="gedit-template-card__phone-screen"
						:src="item.cover"
						:alt="item.title"
					/>
					<img
						class="gedit-template-card__phone-frame"
						:src="iphoneFrameUrl"
						alt=""
					/>
				</div>
			</div>
			<template v-else>
				<img v-if="item.cover" :src="item.cover" :alt="item.title" />
			</template>
			<div
				v-if="showHoverActions"
				class="gedit-template-card__mask"
				:class="{ 'is-admin': isAdmin }"
			>
				<template v-if="isAdmin">
					<button
						type="button"
						class="gedit-template-card__action-btn gedit-template-card__action-btn--edit"
						@click.stop="$emit('edit', item)"
					>编辑</button>
					<button
						type="button"
						class="gedit-template-card__action-btn gedit-template-card__action-btn--preview"
						@click.stop="$emit('preview', item)"
					>预览</button>
					<button
						type="button"
						class="gedit-template-card__action-btn gedit-template-card__action-btn--settings"
						@click.stop="$emit('settings', item)"
					>设置</button>
				</template>
				<template v-else>
					<button
						type="button"
						class="gedit-template-card__action-btn gedit-template-card__action-btn--preview"
						@click.stop="$emit('preview', item)"
					>预览</button>
					<button
						type="button"
						class="gedit-template-card__action-btn gedit-template-card__action-btn--bottom"
						@click.stop="$emit('use', item)"
					>使用此模板</button>
				</template>
			</div>
		</div>
		<div class="gedit-template-card__body">
			<h3 class="gedit-template-card__title" :title="item.title">{{ item.title }}</h3>
			<p v-if="showSubtitle && item.subtitle" class="gedit-template-card__subtitle">{{ item.subtitle }}</p>
			<div v-if="showMeta && item.tags && item.tags.length" class="gedit-template-card__tags">
				<span v-for="tag in item.tags" :key="tag" class="gedit-template-card__tag">{{ tag }}</span>
			</div>
			<div v-if="showMeta" class="gedit-template-card__footer">
				<div class="gedit-template-card__stats">
					<span v-if="item.heat" class="gedit-template-card__stat">
						<FireOutlined />
						{{ item.heat }}
					</span>
					<span v-if="item.views" class="gedit-template-card__stat">
						<EyeOutlined />
						{{ item.views }}
					</span>
				</div>
				<a-button
					v-if="showDetailBtn"
					size="small"
					class="gedit-template-card__detail-btn"
					@click.stop="onDetailClick"
				>查看详情</a-button>
			</div>
		</div>
	</div>
</template>

<script>
	import { FireOutlined, EyeOutlined } from '@ant-design/icons-vue';
	import { LOCAL_ASSET } from '../utils/localAssets.js';

	export default {
		name: 'GEditTemplateCard',
		components: { FireOutlined, EyeOutlined },
		props: {
			item: {
				type: Object,
				required: true,
			},
			variant: {
				type: String,
				default: 'list',
			},
			showSubtitle: {
				type: Boolean,
				default: true,
			},
			showMeta: {
				type: Boolean,
				default: true,
			},
			showDetailBtn: {
				type: Boolean,
				default: true,
			},
			/** 是否展示移入操作层 */
			showHoverActions: {
				type: Boolean,
				default: true,
			},
			/** 管理员展示：编辑 / 预览 / 设置 */
			isAdmin: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['detail', 'click', 'preview', 'use', 'edit', 'settings'],
		data() {
			return {
				iphoneFrameUrl: LOCAL_ASSET.iphoneFrame,
			};
		},
		methods: {
			onDetailClick() {
				this.$emit('detail', this.item);
			},
		},
	};
</script>

<style scoped lang="less">
	.gedit-template-card {
		background: #fff;
		border-radius: 8px;
		overflow: hidden;
		border: 1px solid #eef0f4;
		transition: box-shadow 0.2s, border-color 0.2s;

		&:hover {
			border-color: #d6e4ff;
			box-shadow: 0 4px 16px rgba(40, 90, 249, 0.1);
		}

		&--compact {
			.gedit-template-card__cover {
				height: 120px;
			}

			.gedit-template-card__title {
				padding: 8px 10px 10px;
				font-size: 12px;
				text-align: center;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.gedit-template-card__body {
				padding: 0;
			}
		}

		&--list {
			.gedit-template-card__cover {
				/* 与高级编辑器左侧模板列表一致：约 170×250 */
				height: auto;
				aspect-ratio: 17 / 25;
			}

			.gedit-template-card__body {
				padding: 14px 14px 16px;
			}

			.gedit-template-card__title {
				margin: 0 0 8px;
				font-size: 15px;
				text-align: center;
				font-weight: 600;
				color: #1a1a1a;
				line-height: 1.4;
			}

			.gedit-template-card__subtitle {
				margin: 0 0 10px;
				font-size: 13px;
				color: #8c8c8c;
				line-height: 1.5;
			}
		}

		&--phone {
			background: transparent;
			border: none;
			border-radius: 0;

			&:hover {
				border-color: transparent;
				box-shadow: none;
			}

			.gedit-template-card__cover {
				background: transparent;
			}

			.gedit-template-card__body {
				padding: 14px 8px 8px;
			}

			.gedit-template-card__title {
				margin: 0;
				font-size: 14px;
				text-align: center;
				font-weight: 500;
				color: #fff;
				line-height: 1.4;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}

	.gedit-template-card__cover {
		position: relative;
		background: #f5f7fa;
		overflow: hidden;

		img {
			display: block;
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		&:hover .gedit-template-card__mask {
			opacity: 1;
			visibility: visible;
		}
	}

	.gedit-template-card__phone-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.gedit-template-card__phone {
		position: relative;
		display: inline-block;
	}

	.gedit-template-card__phone-screen {
		position: absolute;
		top: 17px;
		left: 50%;
		transform: translateX(-50%);
		width: 216px;
		height: 422px;
		border-radius: 4px;
		object-fit: cover;
		z-index: 1;
	}

	.gedit-template-card__phone-frame {
		display: block;
		width: auto;
		height: auto;
	}

	.gedit-template-card__mask {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.45);
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.2s;

		&.is-admin {
			flex-direction: column;
			gap: 10px;
		}
	}

	.gedit-template-card__action-btn {
		min-width: 88px;
		padding: 6px 22px;
		border: 1px solid transparent;
		border-radius: 4px;
		font-size: 13px;
		line-height: 1.4;
		cursor: pointer;
		transition: background-color 0.2s, border-color 0.2s, color 0.2s;
		box-sizing: border-box;

		&--edit {
			background: #285af9;
			border-color: #285af9;
			color: #fff;

			&:hover {
				background: #4674fb;
				border-color: #4674fb;
			}
		}

		&--preview {
			background: #00c07d;
			border-color: #00c07d;
			color: #fff;

			&:hover {
				background: #00a86d;
				border-color: #00a86d;
			}
		}

		&--settings {
			background: transparent;
			border-color: #fff;
			color: #fff;

			&:hover {
				background: rgba(255, 255, 255, 0.16);
			}
		}

		&--bottom {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			min-width: 0;
			height: 36px;
			padding: 0;
			border-radius: 0;
			border: none;
			background: #00c07d;
			color: #fff;

			&:hover {
				background: #00a86d;
			}
		}
	}

	.gedit-template-card__tags {
		display: flex;
		flex-wrap: wrap;
		gap: 6px;
		margin-bottom: 12px;
	}

	.gedit-template-card__tag {
		padding: 2px 8px;
		font-size: 12px;
		color: #666;
		background: #f5f6f8;
		border-radius: 4px;
	}

	.gedit-template-card__footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
	}

	.gedit-template-card__stats {
		display: flex;
		align-items: center;
		gap: 12px;
		min-width: 0;
	}

	.gedit-template-card__stat {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		font-size: 12px;
		color: #999;
		white-space: nowrap;
	}

	.gedit-template-card__detail-btn {
		flex-shrink: 0;
		color: #285af9;
		border-color: #285af9;
		border-radius: 4px;
	}
</style>
